import { Link, useLocation } from "react-router-dom";
import { useGlobal } from "../../context/GlobalContext";
import { paginatorArray } from "../../utils/helpers/paginatorArray";
import { memo } from "react";

const Paginator = memo(({paginator}) => {

    const { g } = useGlobal();
    const location = useLocation();

    const aPaginator = paginatorArray(
        paginator.countPages||1,
        paginator.currentPage
    );
       
    const handlePageClick = (page) => {
        paginator.currentPage = page;
        g.setPaginator((prev)=>({
            ...prev,
            [location.pathname] : paginator
        }))
    } 
 
    return (  
        <>
        {paginator &&
        (<nav aria-label="Page navigation example">
                <ul className="pagination mb-0 justify-content-end">
                    
                    <li className="page-item">
                        <span className="page-link" 
                            onClick={()=>handlePageClick(1)}>
                            <span aria-hidden="true">«</span>
                        </span>
                    </li>

                    {aPaginator.map(page=>{
                        const pageTitle = (page>=0) ? page+1 : '...'
                        const pageIndex = Math.abs(page)+1;
                         /*
                        const pageClass = ((page + 1 === paginator.currentPage) || 
                                            ((page===0) && (paginator.currentPage<0)))  ? 'page-item active' : 'page-item';
                                            
                        */
                        const pageClass = ((page + 1 === paginator.currentPage) )  ? 'page-item active' : 'page-item';                  

                        return (
                            <li key={`paginatorPage-${page}`} 
                                className={pageClass}>
                                <span  className="page-link cursor-pointer"
                                    onClick={()=>handlePageClick(pageIndex)}>{pageTitle}</span>
                            </li>
                        )
                    })}

                    <li className="page-item">
                        <span className="page-link" 
                            onClick={()=>handlePageClick(paginator.countPages)}>
                            <span aria-hidden="true">»</span>
                        </span>            
                    </li>

                </ul>
        </nav>)}
        </>
        
    );
},  (prevProps, nextProps) =>{
    return (nextProps.paginator?.currentPage ===-1)
})

export default Paginator;
